<div class="container">
    <div class="row mt-5">
        <div class="col-sm-12">
            <p class="title col-sm-12">Change Password</p>
        </div>
        <div class="col-sm-12">
            <form class="col-sm-12" [formGroup]="passwordGroup" #f="ngForm" (ngSubmit)="onFormSubmit(passwordGroup.value); f.resetForm()">
                <div class="form-group">
                    <input class="form-control" type="password" formControlName="newPassword1" placeholder="New Password">
                    <p class="error" *ngIf="passwordGroup.get('newPassword1').invalid">8 characters is required!!</p>
                </div>
                <div class="form-group">
                    <input class="form-control" type="password" formControlName="newPassword2" placeholder="Verify New Password">
                    <p class="error" *ngIf="passwordGroup.errors?.passwordMatch">Password doesn't match!!</p>
                </div>
                <div class="mt-2">
                    <p class="text-right mr-0"><button mat-raised-button type="submit" [disabled]="passwordGroup.invalid">Change password</button></p>
                </div>
            </form>

        </div>
    </div>
</div>